/* eslint-disable */

export const ShowHideFormUtils = {
    showHideVertical(tableClass, formClass, hide = false) {
        const table = document.querySelector(tableClass);
        const form = document.querySelector(formClass);
        if (hide) {
            if (table.classList.contains("w-6")) {
                table.classList.remove("w-6");
            }
            table.classList.add("w-full");
            if (form.classList.contains("w-6")) {
                form.classList.remove("w-6");
            }
        } else {
            if (table.classList.contains("w-full")) {
                table.classList.remove("w-full");
            }
            table.classList.add("w-6");
            form.classList.add("w-6");
        }
    },
    showHideVerticalCustomWidth(tableClass, formClass, tableWidth, hide = false) {
        if (tableWidth > 100) return;
        const table = document.querySelector(tableClass);
        const form = document.querySelector(formClass);
        if (hide) {
            table.style.width = "100%";
            form.style.width = "0";
        } else {
            table.style.width = tableWidth + "%";
            form.style.width = (100 - tableWidth) + "%";
        }
    },
    showHideHorizontal(formClass, hide = false) {
        const form = document.querySelector(formClass);
        if (hide) {
            if (form.classList.contains("showForm")) {
                form.classList.remove("showForm");
            }
        } else {
            form.classList.add("showForm");
        }
    },
};
